import { ApiError } from '../errors/api-error.js';

export class GdprDashboardApi {
    constructor(client) {
        this.client = client;
        this.basePath = '/gdpr-dashboard';
    }

    async getSummary() {
        try {
            const response = await this.client.get(`${this.basePath}/summary`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    /** ROPA raporu (HTML blob). */
    async getRopaReport() {
        try {
            const response = await this.client.get(`${this.basePath}/ropa-report`, { responseType: 'blob' });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    /** Denetim dosyası (HTML blob). */
    async getAuditPack() {
        try {
            const response = await this.client.get(`${this.basePath}/audit-pack`, { responseType: 'blob' });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
